import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import { Box, Button, Heading, Link } from '@primer/react';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Usage`}</h2>
    <Box display="grid" gridTemplateColumns={['1fr', null, null, null, '1fr 2fr']} gridGap={4} mdxType="Box">
      <div>
        <Link href="https://primer.style/react/ActionMenu" mdxType="Link">
          <img alt="Action menu" src="https://user-images.githubusercontent.com/293280/123880964-95b3a700-d8f8-11eb-9775-cbaf165207ed.png" />
        </Link>
      </div>
      <div>
        <Heading sx={{
          fontSize: 3
        }} mdxType="Heading">To perform an action</Heading>
        <Box as="p" mdxType="Box">
          <p>{`Action menus are used for disambiguation, navigation, or to display secondary options. They appear when users interact with buttons, actions, or other controls.`}</p>
        </Box>
      </div>
      <div>
        <Link href="https://primer.style/react/ActionMenu#with-selection" mdxType="Link">
          <img alt="Action Menu with selection" src="https://user-images.githubusercontent.com/293280/123881067-cdbaea00-d8f8-11eb-98e4-e57c64489308.png" />
        </Link>
      </div>
      <div>
        <Heading sx={{
          fontSize: 3
        }} mdxType="Heading">To make one or more selections</Heading>
        <Box as="p" mdxType="Box">
          <p>{`Action menu can be used for making a selection among a small list of options. The list is usually predefined with system values, but in some cases it can include user-provided data when those are known not to grow into too many items.`}</p>
        </Box>
      </div>
    </Box>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/action-list"
        }}>{`Action list`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://primer.style/react/SelectPanel"
        }}>{`Select panel`}</a></li>
    </ul>
    <h2>{`Accessibility`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "../accessibility/focus-management"
        }}>{`Focus management`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      